import { authName, secretKey } from '../utils/config';
let CryptoJS = require("crypto-js");

export const setToken = async (info: any)=>{
    const encryptionKey = secretKey;
    const jsonDataString = await JSON.stringify(info)
    const encryptedData = CryptoJS.AES.encrypt(jsonDataString, encryptionKey).toString();
    window.localStorage.setItem(authName, encryptedData)
}

export const descriptData = ()=>{
    const encryptionKey = secretKey;
    const storedEncryptedData = localStorage.getItem(authName)        
    if (storedEncryptedData) {
        const decryptedBytes = CryptoJS.AES.decrypt(storedEncryptedData, encryptionKey);
        const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);        
        return decryptedData;
    }
}

export const getUserData = ()=>{
    const data = JSON.parse(descriptData());
    const user = data?.name
    return user
}